import { IServerSideDatasource, IServerSideGetRowsParams } from 'ag-grid-community';
import { EIMMonitoringGridRequest, ExportFilters } from './interfaces';
import { QUERY_INVOICE_STATUS } from './invotrackQueries';
import { Get_InvoicesStatusesQueryResult } from './invotrackQueries.generated';

export default class InvoTrackServerSideDatasource implements IServerSideDatasource {
    private gridOptions: any;
    private client: any;
    private filters: any;
    private env: string;
    private setLastSearch: (param: any) => void;
    private exportFilters: ExportFilters;

    constructor(env,
                gridOptions,
                client,
                filters,
                lastSearch: (param: any) => void,
                exportFilters:ExportFilters) {
        this.env = env;
        this.gridOptions = gridOptions;
        this.client = client;
        this.filters = filters;
        this.setLastSearch = lastSearch;
        this.exportFilters = exportFilters;
    }

    /**
     * Helper to get filter value from filterModel or filters
     * @param filterModel - params.request.filterModel
     * @param filters - this.filters
     * @param key - field name
     * @param type - 'array' or 'text'
     */
    private getFilterValue(filters: any, key: string) {
        return filters[key];
    }

    private mapToActualValues(key:string, array:string[]) {
        if (array?.length) {
            const newArray:string[] = [];

            const actualValues = this.exportFilters[key];
            for (const value of array) {
                for (const actualValue of actualValues) {
                    if (actualValue?.value?.trim().toUpperCase() === value) {
                        newArray.push(actualValue.value);
                    }
                }
            }

            return newArray;
        }

        return array;
    }


    /**
     * Helper to convert array to string with delimiter
     * @param arr
     * @param del
     * @private
     */
    private mapArrayToString(arr: string[], del:string) {
        if (arr && arr.length > 0) {
            return arr.join(del);
        }

        return null;
    }

    getInvoiceStatusRequest(params) {
        const filterModel = params.request.filterModel;
        const invoiceStatusRequest: EIMMonitoringGridRequest = {
            limit: this.gridOptions.cacheBlockSize,
            offset: params.request.startRow ? params.request.startRow : 0,
            page: params.request.endRow ? params.request.endRow : 1,
            fromDate: this.filters?.fromDate?.format('YYYY-MM-DD HH:mm:ss'),
            toDate: this.filters?.toDate?.format('YYYY-MM-DD HH:mm:ss'),
            direction: this.filters.direction,
            companyGroup: this.filters.companyGroup,
            message_id: this.mapArrayToString(this.getFilterValue( this.filters, 'message_id'), ' '),
            partnerno: this.mapArrayToString(this.getFilterValue( this.filters, 'partnerno'),' '),
            vin_number: this.mapArrayToString(this.getFilterValue( this.filters, 'vin_number'), ' '),
            company: this.getFilterValue( this.filters, 'company'),
            sys_id: this.getFilterValue( this.filters, 'sys_id'),
            group_name: this.getFilterValue( this.filters, 'group_name'),
            m_format: this.mapToActualValues('m_format',this.getFilterValue( this.filters, 'm_format')),
            reference: this.mapArrayToString(this.getFilterValue( this.filters, 'reference'), ' '),
            process: this.mapToActualValues('process', this.getFilterValue( this.filters, 'process')),
            m_interface: this.getFilterValue( this.filters, 'm_interface'),
            step_number: this.getFilterValue( this.filters, 'step_number'),
            step: this.getFilterValue( this.filters, 'step'),
            status: this.mapToActualValues('status',this.getFilterValue( this.filters, 'status')),
            cross_border: this.getFilterValue( this.filters, 'cross_border'),
            status_reason: this.getFilterValue( this.filters, 'status_reason'),
            duplicate: this.getFilterValue( this.filters, 'duplicate'),
            inv_status: this.filters?.status?.includes('OVERDUE')? 'OVERDUE': this.filters.inv_status,
            /* --- New fields --- */
            log_info_id: this.getFilterValue( this.filters, 'log_info_id'),
            log_obj_id: this.getFilterValue( this.filters, 'log_obj_id'),
            bmw_int_reference: this.getFilterValue( this.filters, 'bmw_int_reference'),
            ext_reference: this.getFilterValue( this.filters, 'ext_reference'),
            channel: this.getFilterValue( this.filters, 'channel'),
            target_directory: this.getFilterValue( this.filters, 'target_directory'),
            insert_user: this.getFilterValue( this.filters, 'insert_user'),
            update_user: this.getFilterValue( this.filters, 'update_user'),
            insert_ts: this.getFilterValue( this.filters, 'insert_ts'), // date as string
            updatetime: this.getFilterValue( this.filters, 'updatetime'), // date as string
            original_log_obj_id: this.getFilterValue( this.filters, 'original_log_obj_id'),
            sdi_number: this.getFilterValue( this.filters, 'sdi_number'),
            m_process: this.getFilterValue( this.filters, 'm_process'),
            final_completion: this.getFilterValue( this.filters, 'final_completion'), // date as string
            c_status: this.getFilterValue( this.filters, 'c_status'),
            m_provider: this.getFilterValue( this.filters, 'm_provider'),
            received_date: this.getFilterValue( this.filters, 'received_date'), // date as string
            complete_date: this.getFilterValue( this.filters, 'complete_date'), // date as string
            m_invprocess: this.getFilterValue( this.filters, 'm_invprocess'),
            md_process_id: this.getFilterValue( this.filters, 'md_process_id'),
            edi_agreement_date: this.getFilterValue( this.filters, 'edi_agreement_date'), // date as string
            system_id: this.getFilterValue( this.filters, 'system_id'),
            ebox_folder: this.getFilterValue( this.filters, 'ebox_folder'),
            apar: this.getFilterValue( this.filters, 'apar'),
            document_type: this.getFilterValue( this.filters, 'document_type'),
            process_code: this.getFilterValue( this.filters, 'process_code'),
            tax_amount: this.getFilterValue( this.filters, 'tax_amount'),
            currency: this.getFilterValue( this.filters, 'currency'),
            partner_country: this.getFilterValue( this.filters, 'partner_country'),
            partner_name: this.getFilterValue( this.filters, 'partner_name'),
            document_available: this.getFilterValue( this.filters, 'document_available') ? this.getFilterValue( this.filters, 'document_available') === undefined ? undefined :  this.getFilterValue( this.filters, 'document_available') === 'true'? true : false : undefined,
            uuid: this.getFilterValue( this.filters, 'uuid'),
            file_name: this.getFilterValue( this.filters, 'file_name'),
            id_partner: this.getFilterValue( this.filters, 'id_partner'),
            clearing_house: this.getFilterValue( this.filters, 'clearing_house'),
            downloaded: this.getFilterValue( this.filters, 'downloaded'),
            Blob_Id: this.getFilterValue( this.filters, 'Blob_Id'),
            shippartnerno: this.getFilterValue( this.filters, 'shipPartnerNo'),
            edp_relevant: this.getFilterValue( this.filters, 'edp_relevant'),
            route_id: this.getFilterValue( this.filters, 'route_id'),
        };

        console.log(params.request.filterModel);
        console.log(this.filters);
        console.log(invoiceStatusRequest);
        return invoiceStatusRequest;
    }

    getRows(params: IServerSideGetRowsParams) {
        const invoiceStatusRequest = this.getInvoiceStatusRequest(params);
        const sort = [];

        if (params.request.sortModel.length > 0) {
            for (const sortModel of params.request.sortModel) {
                sort.push({
                    property: sortModel.colId === 'creation_ts' ? 'status.updatetime' : sortModel.colId,
                    direction: sortModel.sort,
                });
            }
        }
        sort.push({
            property: 'message_id',
            direction: 'DESC',
        });
        sort.push({
            property: 'step_number',
            direction: 'ASC',
        });
        invoiceStatusRequest.sort = JSON.stringify(sort);
        invoiceStatusRequest.agGridFilters = {...params.request.filterModel};

        this.mapToActualValues('process', invoiceStatusRequest.agGridFilters['process']?.values);
        this.mapToActualValues('status', invoiceStatusRequest.agGridFilters['status']?.values);
        this.mapToActualValues('m_format', invoiceStatusRequest.agGridFilters['m_format']?.values);

        console.log('..................................................');
        console.log(invoiceStatusRequest);
        this.setLastSearch(invoiceStatusRequest);

        this.client
            .query({
                query: QUERY_INVOICE_STATUS,
                variables: {
                    env: this.env,
                    request: invoiceStatusRequest,
                },
                fetchPolicy: 'network-only',
            })
            .then((response: Get_InvoicesStatusesQueryResult) => {
                console.log(`The total value ${response?.data?.getEIMInvoices?.total}`);
                params.success( {
                    rowData:response?.data?.getEIMInvoices?.invoiceStatusesList,
                    rowCount:response?.data?.getEIMInvoices?.total
                    }
                );
            })
            .catch((e) => {
                console.error('Error fetching invoice statuses:', e);
                params.fail();
            });
    }
}
